import { Component, OnInit, HostListener, Renderer2, ElementRef, ViewChildren, QueryList, AfterViewInit, Injectable, Input, OnChanges, SimpleChanges, Output, EventEmitter} from '@angular/core';
import {Company, ConnectionService} from '../../services/Connection/connection.service';
import { ScrollService } from '../../services/Scroll/scroll.service';
import { CacheService } from '../../services/Cache/cache.service';
import { Categorias, typeInterface } from 'src/app/shared/Interfaces/company';
import { SharedService } from '../../services/shared/shared.service';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css']
})
@Injectable({
  providedIn: 'root'
})
export class SideBarComponent  implements OnInit, AfterViewInit, OnChanges {
  @Output() showModalCompany = new EventEmitter<boolean>();
  @Input() sections!: QueryList<ElementRef>
  @ViewChildren('meulink') meuLink!: QueryList<ElementRef>;

//#region Variaveis Locais
  private typeParam!: typeInterface;
  currentSectionIndex: number = 0;
  sectionsPosition: number[] = [];
  imgLogo!: string;
  imgBg!: string;
  company!: Company;
  tabela!: Categorias[];
  clicked = false;
  nameCompany: string | null = '';
  verifiScrolling = false;
  cachePosition: number = 0;
  scrollIndex: number = 0;
  filter: string = '';
  openInfoCompany: boolean = false;
  readOnlyState: boolean = false;
  local: boolean = false;
  statusCompany: boolean = false;
  textStatusCompany: string = '';
  timesInfo: any;
  localCounter: boolean = false;
//#endregion

//#region Inicializadores
  constructor(
    public scrollService: ScrollService,
    private cacheService: CacheService,
    private connection: ConnectionService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private sharedService: SharedService
    )
    {
      this.scrollService.scrolling$.subscribe((scrolling) =>{
        this.verifiScrolling = scrolling;
      })
      this.sharedService.filter$.subscribe((newValue) => {
        this.filter = newValue;
      });
      this.connection.typeParam$.subscribe((newTypeParam) => {
        this.typeParam = newTypeParam;
      })

      this.connection.readOnlyState$.subscribe((data) =>{
        this.readOnlyState = data;
      })

      this.connection.company$.subscribe(newCompany =>{
        this.company = newCompany
        if(this.company)
        {
          this.tabela = this.company.categories;
          this.imgLogo = this.company.company.logo;
          this.imgBg = this.company.company.background;
          this.validStatus();
          this.validTimes();
        }

      })
    }

  ngOnChanges(changes: SimpleChanges): void {
    const index = this.findCurrentSectionIndex(window.scrollY);
    setTimeout(() => {
      this.colorBar(index)
    }, 100);
  }

  ngOnInit(): void {
    if(this.typeParam.type == 1 || this.typeParam.type == 2){
      this.local = true;
    }
    else{
      this.local = false;
    }

    if(this.typeParam.type == 3){
      this.localCounter = true;
    }
    else{
      this.localCounter = false;
    }

  }
  ngAfterViewInit(){
    if(this.verifiScrolling)
    {
      this.scrollIndex = this.scrollService.getScrollIndex()
      this.cachePosition = this.scrollService.getScrollPosition()

        if(this.scrollIndex == 0){
          this.colorBar(this.cacheService.getItemSession('index'))
          this.cacheService.removeItemSession('index')
        }
        else{
          this.colorBar(this.scrollIndex)
          this.cacheService.removeItemSession('index')
        }

        window.scrollTo({
          behavior: 'instant' as ScrollBehavior,
          top: this.cachePosition,
          left: 0
        })
    }
    else{
      setTimeout(() => {
        this.colorBar(0)
      }, 1000);
    }

    setTimeout(() => {
      this.calculateSectionPositions();
    }, 1000);

  }
//#endregion

//#region Funções de estilo (Style)

  colorBar(currentSectionIndex: number){

    const navLinks = this.elementRef.nativeElement.querySelectorAll('.menu-side-bar ul li a');

    this.meuLink.forEach(function(link) {
      link.nativeElement.classList.remove('active');
    });
    if(navLinks[currentSectionIndex]){
      this.renderer.addClass(navLinks[currentSectionIndex], 'active')
    }

  }

  sharedEvent(){
    this.showModalCompany.emit(true);
  }

  colorBarClick(event: Event, index: number): void{
    let scrollOffSet = 0;

    this.meuLink.forEach((element: ElementRef) =>{
      element.nativeElement.classList.remove('active')
    });

    const element = event.target as HTMLElement;

    element.classList.add('active')
    this.clicked = false;
    this.scrollToSection(index)


  }

  findCurrentSectionIndex(currentScrollY: number): number {
    if(this.sectionsPosition.length != 0){
      for (let i = this.sectionsPosition.length - 1; i >= 0; i--) {
        if (currentScrollY >= this.sectionsPosition[i] - 85) {
          return i;
        }
      }
    }
    else{
      let sectionArray: any;
      if(this.sections)
      {
        sectionArray = this.sections.toArray();

        for (let i = sectionArray.length - 1; i >= 0; i--) {
          if (currentScrollY >= sectionArray[i].nativeElement.offsetTop - 85) {
            return i + 1;
          }
        }
      }
    }
    return 0;
  }

  scrollToSection(index: number){
    window.scrollTo({top: this.sectionsPosition[Number(index)], behavior: 'smooth'});
  }

  calculateSectionPositions() {
    // Assuma que você tem uma lista de seções no seu componente
    if(this.sections){
      this.sections.forEach(section => {
        if (section && section.nativeElement) {

          this.sectionsPosition.push(section.nativeElement.offsetTop - 160);
        }
      });
    }

  }

  private isScrolledToBottom(): boolean {
    const windowHeight = 'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    const windowBottom = windowHeight + window.pageYOffset;

    return windowBottom >= docHeight;
  }

  @HostListener('window:scroll', [])
  onScroll(){
    if(!this.clicked)
    {
      const scrollY = window.scrollY;
      const newSectionIndex = this.findCurrentSectionIndex(scrollY);

      if (newSectionIndex !== this.currentSectionIndex) {
        this.currentSectionIndex = newSectionIndex;
        this.colorBar(newSectionIndex);
      }
    }
    if (this.isScrolledToBottom()) {
      if(this.sections){
        const number = this.sections.length - 1;
        this.colorBar(number)
        console.log('Você atingiu o final da página!');
      }
 
    }



  }

  validStatus(){
    if(this.company.company.status == 0){
      this.statusCompany = false;
      this.textStatusCompany = 'Loja Fechada';
    }
    else{
      this.statusCompany = true;
      this.textStatusCompany = 'Loja Aberta';
    }
  }

  //Valida os tempos de preparo
  validTimes() {
    const { deliveryFrom, deliveryTo, counterFrom, counterTo } = this.company.company.times;
  
    this.timesInfo = {
      delivery: {
        active: !(deliveryFrom === 0 && deliveryTo === 0),
        label: this.formatTimeRange(deliveryFrom, deliveryTo)
      },
      counter: {
        active: !(counterFrom === 0 && counterTo === 0),
        label: this.formatTimeRange(counterFrom, counterTo)
      }
    };
  }

  private formatTimeRange(from: number, to: number): string {
    if (!from && !to) return '';
  
    if (from && to) {
      return `${this.formatMinutes(from, 1)} - ${this.formatMinutes(to, 2)}`;
    }
  
    const value = from || to;
    return this.formatMinutes(value, 0);
  }
  
  private formatMinutes(minutes: number, type: number): string {
    if (!minutes) return '';
  
    if(type == 1){
      if (minutes < 61) return `${minutes}`;
    }
    else {
      if (minutes < 61) return `${minutes} min`;
    }

  
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
  
    if (hours && mins) {
      return `${hours}h${mins}min`;
    }
  
    return `${hours}h`;
  }

  //Função de compartilhar o link do cardápio
  share(): void {
    if (navigator.share) {
      navigator.share({
        title: `Acesse o cardapio de ${this.company.company.companyName}`,
        url: `https://pedeaqui.app/${this.nameCompany}`
      }).then(() => {
        console.log('Compartilhado com sucesso!');
      })
      .catch(console.error);
    } else {
      }
  }

//#endregion

}
